module.exports = __webpack_public_path__ + "static/media/redeem-step-2.797a6b0d.svg";